<button class="btn btn-primary btn-block" [disabled]="!isEnabled || isBlocked || isLocked" (click)="redirectTicket()" title="{{ tooltipTitle }}" #button>
    <i class="fas fa-share" #icon></i>
    <span class="element-text">{{ 'console.redirect' | translate }}</span>
</button>